import React, { useEffect, useState } from 'react';
import CopsPageContainer from '../components/CopsPageContainer';
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import AsianImage from '../components/AsianImage';
import ShareIcon from '@mui/icons-material/Share';

import { sectionImages } from '../images';

import { color } from '../elements';

const sectionImagesList = Object.values(sectionImages);
const initialValue = {
  name: '',
  phoneNumber: '',
  isAgreed: false,
};
const Home = () => {
  const [formData, setFormData] = useState(initialValue);

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = () => {
    // 데이터를 서버로 보내는 로직을 작성
    if (formData.name.trim() === '') {
      return window.alert('이름을 입력하세요');
    }

    if (!/^\d+$/.test(formData.phoneNumber)) {
      return window.alert('전화번호는 숫자로만 구성되어야 합니다.');
    }

    if (!formData.isAgreed) {
      return window.alert('개인정보 처리방침에 동의해주세요!');
    }
    // formData 객체에 필요한 데이터가 포함되어 있습니다.
    console.log('보내는 데이터:', formData);

    fetch(
      'https://iwlzo00hhd.execute-api.ap-northeast-2.amazonaws.com/prod/user',
      {
        method: 'POST',
        body: JSON.stringify(formData),
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        console.log('서버 응답:', data);
        setFormData(initialValue);
        window.alert('신청이 완료되었습니다.');
        // 서버 응답을 처리
      })
      .catch((error) => {
        console.error('서버 요청 오류:', error);
        // 오류 처리
      });
    // 나머지 서버 통신 로직을 추가
  };

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const hoverImgPreload = (images) => {
    images.forEach((image) => {
      const img = new Image();
      img.src = image;
    });
  };
  const handleShareClick = async () => {
    // 공유 기능을 추가하는 로직을 여기에 추가하세요.
    const test = {
      title: '아시아인베스트먼트',
      text: '아시아인베스트먼트',
      url: window.location.href,
    };

    if (navigator.share) {
      navigator.share(test);
      await navigator.clipboard?.writeText(window.location.href);
    } else {
      await navigator.clipboard?.writeText(window.location.href);
      alert('링크가 공유되었습니다.');
    }
  };
  useEffect(() => {
    hoverImgPreload(sectionImagesList);
  }, []);
  return (
    <CopsPageContainer>
      {/* 헤더 */}
      {/* 메인섹션 */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <AsianImage
          src={sectionImages.Logo}
          height="200px"
          my={{ xs: 0, sm: 10 }}
          width={'100%'}
          sx={{
            objectFit: 'cover',
          }}
        ></AsianImage>
      </Box>
      {/* 메인섹션 */}
      <Box
        sx={{
          height: {
            // xs: `100vh`, // default
          },
        }}
      >
        <AsianImage
          src={sectionImages.Main}
          width="100%"
          height="100%"
          sx={{
            objectFit: 'cover',
          }}
        ></AsianImage>
      </Box>
      {/* 버튼섹션 */}
      <Box
        onClick={() => scrollToSection('contactSection')}
        sx={{
          cursor: 'pointer',
          height: {
            backgroundColor: '#fff',
            py: 4,
            // xs: `100vh`, // default
          },
        }}
      >
        <AsianImage
          src={sectionImages.Trigger}
          width="100%"
          height="100%"
          sx={{
            objectFit: 'cover',
          }}
        ></AsianImage>
      </Box>

      {/* 뉴스섹션 */}
      <Box
        sx={{
          height: {
            // xs: `100vh`, // default
          },
        }}
      >
        <AsianImage
          src={sectionImages.NewsText}
          width="100%"
          height="100%"
          sx={{
            objectFit: 'cover',
          }}
        ></AsianImage>
      </Box>
      {/* 뉴스섹션 */}
      <Box
        sx={{
          height: {
            // xs: `100vh`, // default
          },
        }}
      >
        <AsianImage
          src={sectionImages.News}
          width="100%"
          height="100%"
          sx={{
            objectFit: 'cover',
          }}
        ></AsianImage>
      </Box>

      {/* 수상섹션 */}
      <Box
        sx={{
          my: -1,
          height: {
            // xs: `100vh`, // default
          },
        }}
      >
        <AsianImage
          src={sectionImages.Award}
          width="100%"
          height="100%"
          sx={{
            objectFit: 'cover',
          }}
        ></AsianImage>
      </Box>

      {/* 헬프섹션 */}
      <Box
        sx={{
          py: 5,
          backgroundColor: 'black',
          mb: -1,
          height: {
            // xs: `100vh`, // default
          },
        }}
      >
        <AsianImage
          src={sectionImages.Help}
          width="100%"
          height="100%"
          sx={{
            objectFit: 'cover',
          }}
        ></AsianImage>
      </Box>

      {/* 강조섹션 */}
      <Box
        sx={{
          mb: -1,
          height: {
            // xs: `100vh`, // default
          },
        }}
      >
        <AsianImage
          src={sectionImages.Focus}
          width="100%"
          height="100%"
          sx={{
            objectFit: 'cover',
          }}
        ></AsianImage>
      </Box>
      {/* Contact섹션 */}

      <Stack
        id={'contactSection'}
        // width={'50vw'}
        p={10}
        bgcolor={'#f1f2f7'}
        textAlign={'center'}
      >
        <Typography
          fontSize={'24px'}
          my={1}
          fontWeight={'bold'}
          letterSpacing={-0.8}
        >
          무료 보유종목 진단받기
        </Typography>
        <Typography
          fontSize={'18px'}
          mb={2}
          fontWeight={'500'}
          letterSpacing={-0.8}
        >
          제2의 연봉을 만드는 가장 쉬운 방법
        </Typography>
        <TextField
          fullWidth
          label="이름"
          variant="outlined"
          sx={{ marginBottom: 2 }}
          name="name"
          value={formData.name}
          onChange={handleChange}
        />
        <TextField
          label="전화번호"
          variant="outlined"
          name="phoneNumber"
          value={formData.phoneNumber}
          onChange={handleChange}
        />
        <FormControlLabel
          control={<Checkbox onChange={handleChange} />}
          label="개인정보 처리방침 동의"
          name="isAgreed"
          checked={formData.isAgreed}
        />
        <Button
          onClick={handleSubmit}
          variant="contained"
          sx={{
            mt: 2,
            py: 2,
            backgroundColor: 'red',

            '&:hover': {
              borderColor: '#318E89',
              bgcolor: 'red', // 마우스 호버 시 border 색상 변경
              color: color.white, // 마우스 호버 시 텍스트 색상 변경 (선택 사항)
            },
          }}
        >
          <Typography>무료정보받기신청</Typography>
        </Button>
      </Stack>

      <Button
        variant="contained"
        color="primary"
        onClick={handleShareClick}
        sx={{
          height: 60,
          width: 50,
          borderRadius: '50%',
          position: 'fixed',
          backgroundColor: '#ffffff', // 버튼 배경색
          color: 'red', // 아이콘 색상을 흰색으로 설정합니다.

          bottom: '20px', // 화면 하단 여백 조절
          right: '20px', // 화면 우측 여백 조절
          zIndex: 1000, // 다른 요소 위에 나타나도록 설정
          '&:hover': {
            borderColor: '#318E89',
            bgcolor: 'red', // 마우스 호버 시 border 색상 변경
            color: color.white, // 마우스 호버 시 텍스트 색상 변경 (선택 사항)
          },
        }}
      >
        <ShareIcon />
      </Button>
      {/* 헬프섹션 */}
      <Box
        sx={{
          backgroundColor: 'black',
          height: {
            // xs: `100vh`, // default
          },
        }}
      >
        <AsianImage
          src={sectionImages.Footer}
          width="100%"
          height="100%"
          sx={{
            objectFit: 'cover',
          }}
        ></AsianImage>
      </Box>
    </CopsPageContainer>
  );
};

export default Home;
